<template>
    <v-container grid-list-md fluid fill-height>
        <v-layout row wrap style="width: 100%;">
            <v-flex >
                <v-card>
                    <statistics-marks-by-departments-index :key="$route.fullPath"/>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import StatisticsMarksByDepartmentsIndex
        from "@/components/admin/StatisticsMarks/StatisticsMarksByDepartments/StatisticsMarksByDepartmentsIndex";

    export default  {
        components: {
            StatisticsMarksByDepartmentsIndex,
        },
        data: () => {
            return {
             

            };
        },
    }
</script>